<div class="container">
    <div class="col-md-12 empl-tptxt">
        <h3>Knowledge Bank</h3>
    </div>
    <div class="col-12">
        <div class="row">
            <app-summary-data-table [options]="summaryOptions" [data]="summaryData" />
        </div>
    </div>
    <br />
    <div class="row">
        <div class="col-12 my-3 text-end align-self-end mt-3">
            <button type="button" class="btngbdpg-viwall" (click)="back()">Back</button>
        </div>
    </div>
</div>
